module.exports = __webpack_public_path__ + "img/rtc3.fe506d37.jpg";